import React from 'react';
import { connect } from 'react-redux';
import { DragPreviewImage, useDrag } from 'react-dnd';
import PropTypes from 'prop-types';

import handleKeyPress from '../../../common/handleKeyPress';
import * as itemTypes from '../../../constants/itemTypes/itemTypes';
import imageSources from '../../../constants/imageSources/imageSources';
import CustomTooltip from '../../../componentLibrary/CustomTooltip';
import { blockType } from '../../../types';
import * as Styled from './styles';
import { useAddBlock } from '../../../common/useAddBlock';

const borderColors = {
    'text-headline': '#009BF2',
    'table-content': '#A65570',
    'sb-post-empty': '#009BF2',
    'image-paragraph': '#EC7100',
    'image-text-columns': '#EC7100',
    'video-text': '#B569B4',
    'text-quote': '#009BF2',
    'social-links': '#0D6EFD',
    'line-divider': '#21C5DA',
    'survey-social-reactions': '#4AA910',
    'survey-thumbs': '#4AA910',
    'survey-stars': '#4AA910',
    'survey-numeric': '#4AA910',
    'survey-enps': '#4AA910',
};

const DraggablePresetBlock = (props) => {
    const { createBlockContent, nameRef, isEnabled, disabledTooltipText, dispatch, lastBlock } = props;

    const addBlock = useAddBlock({ lastBlock, generateBlock: createBlockContent, dispatch });

    const [{ isDragging, handlerId }, drag, dragPreview] = useDrag(() => ({
        type: itemTypes.STATIC_BLOCK,
        item: () => {
            const newBlock = createBlockContent();
            return { newBlock };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(), // https://github.com/react-dnd/react-dnd/issues/2774
        }),
    }));

    const block = createBlockContent();
    return (
        <>
            <DragPreviewImage connect={dragPreview} src={imageSources.BLOCK_THUMBNAILS(nameRef, true)} />
            <div
                ref={drag}
                data-handler-id={handlerId}
                data-tip
                data-for={nameRef}
                data-test-id={`quickblock-${nameRef}`}
            >
                <Styled.Div
                    onClick={() => (isEnabled ? addBlock() : null)}
                    onKeyDown={(e) => handleKeyPress(e, () => (isEnabled ? addBlock() : null), true)}
                    tabIndex={0}
                    imageSource={imageSources.BLOCK_THUMBNAILS(nameRef, false)}
                    border={borderColors[nameRef]}
                    isDragging={isDragging}
                    isEnabled={isEnabled}
                    role="button"
                    aria-label={`Add ${nameRef.replace('-', ' ')} quickblock to canvas`}
                >
                    <Styled.BlockHeading>{block.title}</Styled.BlockHeading>
                    {!isEnabled && (
                        <CustomTooltip dataRef={nameRef} effect="float" width={140} text={disabledTooltipText} />
                    )}
                </Styled.Div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    lastBlock: state.canvasBlocks.present[state.canvasBlocks.present.length - 1],
});

DraggablePresetBlock.propTypes = {
    dispatch: PropTypes.func.isRequired,
    createBlockContent: PropTypes.func.isRequired,
    nameRef: PropTypes.string.isRequired,
    lastBlock: blockType,
    isEnabled: PropTypes.bool.isRequired, // defaultProps true did not work since we are checking for the prop in DragSource
    disabledTooltipText: PropTypes.string,
};

DraggablePresetBlock.defaultProps = {
    lastBlock: null,
    disabledTooltipText: '',
};

export default connect(mapStateToProps)(DraggablePresetBlock);
